import { Component, Inject, OnInit, TemplateRef } from "@angular/core";
import { AuthService } from "src/app/services/auth.service";
import { HttpClient } from "@angular/common/http";
import { Router, NavigationEnd } from "@angular/router";
import { DomSanitizer } from "@angular/platform-browser";
import { ModuleService } from "src/app/services/module.service";
import { BlockUI, NgBlockUI } from "ng-block-ui";
import { ToastrService } from "ngx-toastr";
import * as objectPath from 'object-path';
import { filter } from "rxjs/operators";
import { DOCUMENT } from "@angular/common";
import { SiteService as SiteService1 } from "src/app/services/site.service";
import { SiteService } from "src/app/new-sites-management/common/services/site.service";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";


var ver = window["config"].version;
@Component({
  selector: "app-theme-calendar",
  template: `<p class="btn kt-subheader__btn-daterange disabled">
    <span class="kt-subheader__btn-daterange-title"> Today:</span>&nbsp;
    <span class="kt-subheader__btn-daterange-date">
      {{ todate | date: "MMMM d" }}</span
    >
  </p>`,
})
export class ThemeCalenderComponent {
  todate = new Date();
}

@Component({
  selector: "app-main",
  templateUrl: "./main.component.html",
  styleUrls: ["./main.component.css"],
})
export class MainComponent implements OnInit {
  user: any = {};
  allUserSites: any = [];
  defaultSites: any = {};
  loadSite: boolean;
  HostNames: any = [];
  vr = ver;
  lstMenu: any;
  sPageName = '';
  oCurrentPage: any;
  dateNow: any = new Date();
  asideSelfDisplay: true;
  oApplication: any;
  sModuleName = '';
  lstReminders;
  @BlockUI() blockUI: NgBlockUI;
  public lstLeftMenu: any = [];
  public isCoreIntegration: any;
  public parent: any;
  public menu: any;
  modalRef: BsModalRef;
  constructor(
    private modalService: BsModalService,
    private authService: AuthService,
    private sanitizer: DomSanitizer,
    private router: Router,
     private snotifyService: ToastrService,
    private httpClient: HttpClient,
    private moduleService: ModuleService,
    public siteService: SiteService,
    public siteService1: SiteService1,
    @Inject(DOCUMENT) private document: Document,
  ) {
    
    this.router.events.subscribe((ev) => {
      if (ev instanceof NavigationEnd) {
        setTimeout(() => {
          this.loadScript();
        }, 0);
      }
    });
  }

  defaultSite = ""
  ngOnInit() {
    this.isCoreIntegration = localStorage.getItem('coreIntegration');
    this.siteService1.allUserSites$.subscribe((res) => {
      if (res)
        this.defaultSite = res.find(x => x.isDefault).name;
    })

    this.user = this.authService.getLoggedUser();
    this.authService.user = this.user;
    this.authService.siteId = this.user.siteId;
    /*  this.siteService.SiteChanged().subscribe((value) => {
       if (value) {
         this.GetAllSites();
       }
     }); */
    this.siteService1.getSites().subscribe();
    // this.GetAllSites();
    this.setPreveiwLink();
    this.loadSite = true;
    this.GetModules();
    //this.LoadAuthorizedMenu();
  }


  openDeleteDialog(template: TemplateRef<any>) {
    
    this.modalRef = this.modalService.show(template);
  }
  
  setMenue(parent, menu) {
    this.menu = menu;
    this.parent = parent;
  }

  public clearCache(){
    this.siteService.clearCache().subscribe(()=>{
      this.snotifyService.success("", "Cache Is Cleared Successfully", {
        timeOut: 2000,
        progressBar: true,
        tapToDismiss: true,
      });
    },
    ()=>{
      this.snotifyService.error("", "Something went wrong!!", {
        timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
      });
    });
    this.modalRef.hide()
  }

  public PerformMenu() {
    this.oCurrentPage = this.lstMenu.filter(x => x.URL.includes(this.router.url));
    if (this.oCurrentPage.length > 0) {
      this.sPageName = this.oCurrentPage[0].NAME;
      var vParent = this.lstMenu.filter(x => x.ID == this.oCurrentPage[0].CAM_SMU_ID)[0];
      if (vParent != undefined)
        this.sModuleName = vParent.NAME;
      // this.CheckDisabledControls();
    } else {
      this.sPageName = "";
      this.sModuleName = "";
    }
  }
  GetModules() {
    const service = this.moduleService;
    this.moduleService.loadModules().subscribe((res) =>
    // let data= [
    //   {
    //     "moduleName": "CommonSettingLibModule",
    //     "path": "../../assets/bundels/common-setting-component-lib"
    //   },
    //   {
    //     "moduleName": "EcommerceSettingModule",
    //     "path": "../../assets/bundels/ecommerce-setting-component-lib"
    //   },
    //     {
    //     "moduleName": "IntranetSettingModule",
    //     "path": "../../assets/bundels/intranet-setting-component-lib"
    //   }
    // ]
    res.forEach(async(m) => {
        this.blockUI.start();

       await this.moduleService.loadModuleSystemJS(m).then(
          (exports) => {
            console.log(exports)
            service.setComponentFactories(exports);
            this.blockUI.stop();
            this.blockUI.resetGlobal()
          },
          (err) => {
            this.blockUI.stop();
            this.blockUI.resetGlobal()
          }
        );
      })
    );
  }

  ngAfterViewInit() {
    const head = document.getElementsByTagName("body")[0];
    const script = document.createElement("script");
    script.src = "./assets/js/scripts.bundle.js";
    script.type = "text/javascript";
    var oldJs = document.getElementsByTagName("script");
    for (let index = 0; index < oldJs.length; index++) {
      const element = oldJs[index];
      if (element.src.indexOf("scripts.bundle.js") != -1) {
        head.removeChild(element);
        index = index - 1;
      }
    }
    head.appendChild(script);
  }

  loadScript() {
    /*  const head = document.getElementsByTagName("body")[0];
     const script = document.createElement("script");
     script.src = "./assets/js/pages/dashboard.js";
     script.type = "text/javascript";
     var oldJs = document.getElementsByTagName("script");
     for (let index = 0; index < oldJs.length; index++) {
       const element = oldJs[index];
       if (element.src.indexOf("dashboard.js") != -1) {
         head.removeChild(element);
         index = index - 1;
       }
     }
     head.appendChild(script); */
  }

  GetAllSites() {
    this.siteService1.getSites().subscribe((res: any) => {
      this.allUserSites = res;
      for (let index = 0; index < this.allUserSites.length; index++) {
        const s = this.allUserSites[index];
        if (s.isDefault == 1) {
          this.defaultSites = s;
          // this.authService.siteCultures = s.siteCultures;
          return;
        }
      }

    });
  }

  openNotifySuccess(message: string) {
    this.snotifyService.success("", message, {
      timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }
  home() {
    let HomePages = this.lstMenu.filter(x => x.CAM_SMU_ID == this.lstLeftMenu[0].ID);
    this.setMenue(this.lstLeftMenu[0].NAME, HomePages[0].NAME);
    this.router.navigate(['']);
  }
  openNotifyError(message: string) {
    this.snotifyService.error(message, "Something went wrong!!", {
     timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }
  loggeOut() {
    this.authService.loggeOut();
  }

  makeDefault(site) {
    sessionStorage.removeItem("blogArticlesSearchQuery");

    const data = {
      SiteId: site.siteId,
      IsDefault: 1,
    };
    this.loadSite = false;
    this.httpClient
      .post("/Sites/SetSiteAsDefault", data)
      .subscribe((data: any) => {
        if (data.isSuccessStatusCode == false) this.openNotifyError("error");
        else {
          this.openNotifySuccess(site.name + " Marked as default");
          this.authService.siteId = site.siteId;
          const userData = JSON.parse(localStorage.getItem('userData'));
          userData.DefaultSiteInfo.siteId =site.siteId;
          localStorage.setItem('userData', JSON.stringify(userData));
          this.loadSite = true;
          this.defaultSite = site.name
          this.siteService1.reset();
          if (this.router.url.indexOf("/page-builder") != -1) {
            this.router.navigate(["pages"]);
          }
          if (this.router.url.indexOf("/templates-builder") != -1) {
            this.router.navigate(["page-templates"]);
          }
          // this.router.navigated = false;
          // this.router.navigate(['sites']);
          // this.GetAllSites();
          this.siteService1.getSites().subscribe();
          this.setPreveiwLink();
          this.loadScript();
        }
        setTimeout(() => this.siteService.updateSitesChanged(), 10);
      });
  }

  setPreveiwLink() {
    this.HostNames = [];
    this.httpClient
      .get("/Sites/GetSiteDetails/" + this.authService.siteId)
      .subscribe((res: any) => {
        for (let index = 0; index < res.hostNames.length; index++) {
          const h = res.hostNames[index];
          this.HostNames.push({
            HostName: h.hostName,
            LogoId: h.logoId,
            CultureCodeId: h.cultureCodeId,
            link: this.sanitizer.bypassSecurityTrustUrl("http://" + h.hostName),
          });
        }
      });
  }
  navigateToNotification(){
    this.router.navigate(['/notifications'],{ queryParams: {notficationInbox: true}});
  }
}
